export default function getHtmlImage(html, callback) {
  // let re = /<img.*?src=['"](.*?)['"]/;
  // let results = re.exec(html);

  let parser = new DOMParser();
  let doc = parser.parseFromString(html, "text/html");
  const images = $(doc).find("img:not(.emoji)");
  // const images = doc.getElementsByTagName('img')

  if (images.length > 0) {
    for (let i = 0; i < images.length; i++) {
      const image = images[i];
      const imageSrc = $(images[i]).prop('src');
      checkImage(imageSrc, function () {
        callback([image, imageSrc]);
      });
      break;
    }
    return true;
  }
  return false;
}
function checkImage(imageSrc, good, bad) {
  var img = new Image();
  img.onload = good;
  img.onerror = bad;
  img.src = imageSrc;
}
flarum.reg.add('ziiven-ziven-core', 'common/helpers/getHtmlImage', getHtmlImage);